import React, { useEffect } from 'react';
// import logo from './logo.svg';
import './App.css';
// import MainBody from './components/MainBody';
// import BlogMarkdown from './components/BlogMarkdown';
// import BlogsMenu from './components/BlogsMenu'
import { BrowserRouter as Router, Switch } from "react-router-dom";
import Routes from './components/Routes';
import MyNavBar from './components/NavBar';
import { createBrowserHistory } from 'history';


const history = createBrowserHistory();

function App() {

  useEffect(()=>{
    // this is for the goatcounter analytics
    const script = document.createElement("script")
    script.src="/scripts/count.js"
    script.setAttribute("data-goatcounter", "https://brilliant.goatcounter.com/count")
    document.body.appendChild(script);
  })


  let returnComp =  (
    <Router
    //@ts-ignore
     history={history}>
      <MyNavBar />
      <Switch>
        <Routes />
      </Switch>
    </Router>
  );
  return returnComp;
}

export default App;
